// https://stackoverflow.com/questions/62210286/declare-type-with-react-useimperativehandle
// https://github.com/jaredpalmer/formik/issues/1603#issuecomment-575669249

import {
  Box,
  Button,
  ButtonGroup,
  FormLabel,
  HStack,
  Stack,
  StackDivider,
  Text,
} from "@chakra-ui/react";
import { Field, Form as FormikForm, Formik, FormikHelpers } from "formik";
import React from "react";
import {
  FormInputControl,
  FormSingleCheckbox,
} from "../../../components/forms";
import { FormSelectControl } from "../../../components/forms/SelectControl";
import { GeneialFieldVersionTypeEnum } from "../models/GeneialFieldVersion";
import { ICompleteGeneialSchemaVersion } from "../models/GeneialSchema";

import { IRegistryWorkingForm } from "../models/Registry";
import { ADD_RECORD_EXCLUDE_FIELDS } from "./CreateRegistryRecordContainer";

interface IProps {
  registrySchema: ICompleteGeneialSchemaVersion;
  validationSchema: any;
  initialValues: any;
  isLoading: boolean;
  onSubmit: (any) => Promise<void>;
  onClose: () => void;
}

export const CreateRegistryRecordForm = ({
  onClose,
  registrySchema,
  validationSchema,
  isLoading,
  initialValues,
  onSubmit,
}: IProps) => {
  const [workingFormValues] =
    React.useState<IRegistryWorkingForm>(initialValues);

  // console.log("initialValues", initialValues);
  // console.log("registrySchema", registrySchema);
  // console.log("validationSchema", validationSchema);

  const bagRef = React.useRef<any>();

  const handleOnSubmit = async (values, actions: FormikHelpers<any>) => {
    actions.setStatus();
    actions.setSubmitting(true);

    try {
      // Pass up logic
      await onSubmit(values);
      // onClose();
    } catch (error) {
      // Error submitting form, set status for display
      actions.setStatus("Failed to add record message. Please try again.");
    }

    actions.setSubmitting(false);
  };

  return (
    <Box>
      <Formik
        innerRef={bagRef}
        validationSchema={validationSchema}
        initialValues={workingFormValues}
        onSubmit={(values, actions) => {
          handleOnSubmit(values, actions);
        }}
        enableReinitialize={true}
      >
        {(props) => {
          console.log("props.errors", props.errors);
          return (
            <FormikForm>
              <Stack spacing={12} divider={<StackDivider />}>
                {registrySchema &&
                  registrySchema.schemas.map((schemaNode) => {
                    return (
                      <Stack key={schemaNode.id}>
                        <Stack spacing={0}>
                          <HStack>
                            <Text textStyle={"title"}>
                              {schemaNode?.schema_title}
                            </Text>
                            <Text textStyle={"description"} color="text.soft">
                              Version: {schemaNode?.version_major}.
                              {schemaNode?.version_minor}.
                              {schemaNode?.version_patch}
                            </Text>
                          </HStack>
                          <Text textStyle={"description"}>
                            {schemaNode?.schema_description}
                          </Text>
                        </Stack>

                        <Stack spacing={8}>
                          {schemaNode &&
                            schemaNode.fields &&
                            schemaNode.fields
                              .filter(
                                (schemaField) =>
                                  !schemaField.is_excluded &&
                                  ADD_RECORD_EXCLUDE_FIELDS.indexOf(
                                    schemaField.field_key
                                  ) === -1 &&
                                  schemaField.field_type !==
                                    GeneialFieldVersionTypeEnum.calc
                                  && schemaField.field_type != 
                                    GeneialFieldVersionTypeEnum.calc_on_read
                                  && schemaField.field_type !=
                                    GeneialFieldVersionTypeEnum.calc_on_write
                              )
                              .map((schemaField) => {
                                return (
                                  <Stack key={schemaField.id}>
                                    <Box>
                                      {schemaField.field_type ===
                                        GeneialFieldVersionTypeEnum.checkbox && (
                                        <Box>
                                          <Stack>
                                            <Stack spacing={0}>
                                              <Stack direction={'row'} spacing={-2}>
                                                <Box>
                                                  <FormLabel mb={0}>
                                                    {schemaField?.display_name ||
                                                    schemaField?.field_key}
                                                  </FormLabel>
                                                </Box>
                                                <Box>
                                                  {schemaField?.is_required ? <Text
                                                  color="red.500">
                                                  *</Text> : null}
                                                </Box>
                                              </Stack>
                                              <Text
                                                textStyle={"description"}
                                                color="text.soft">
                                                {schemaField?.help_text}
                                              </Text>
                                            </Stack>
                                            {schemaField.options &&
                                              schemaField.options
                                                .filter(
                                                  (option) => option.lookup_key
                                                )
                                                .map((option) => (
                                                  <FormSingleCheckbox
                                                    key={option.lookup_key}
                                                    label={option.label}
                                                    name={
                                                      option.lookup_key as string
                                                    }
                                                    value={option.value}
                                                  >
                                                    <Text ml={2}>
                                                      {option.label}
                                                    </Text>
                                                  </FormSingleCheckbox>
                                                ))}
                                          </Stack>
                                        </Box>
                                      )}

                                      {(schemaField.field_type ===
                                        GeneialFieldVersionTypeEnum.radio ||
                                        schemaField.field_type ===
                                          GeneialFieldVersionTypeEnum.yesno) && (
                                        <Box>
                                          <Stack>
                                            <Stack spacing={0}>
                                              <Stack direction={'row'} spacing={-2}>
                                                <Box>
                                                  <FormLabel mb={0}>
                                                    {schemaField?.display_name ||
                                                      schemaField?.field_key}
                                                  </FormLabel>
                                                </Box>
                                                <Box>
                                                  {schemaField?.is_required ? <Text
                                                  color="red.500">
                                                  *</Text> : null}
                                                </Box>
                                              </Stack>
                                              <Text
                                                textStyle={"description"}
                                                color="text.soft"
                                              >
                                                {schemaField?.help_text}
                                              </Text>
                                            </Stack>

                                            <div
                                              role="group"
                                              aria-labelledby="my-radio-group"
                                            >
                                                {schemaField.options &&
                                                  schemaField.options.map(
                                                    (option) => (
                                                        <Box>
                                                        <HStack
                                                          key={`${option.label}-${option.value}`}
                                                        >
                                                          <Field
                                                            isRequired={schemaField?.is_required}
                                                            type="radio"
                                                            name={
                                                              schemaField.field_key
                                                            }
                                                            value={option.value.toString()}
                                                          />
                                                          <Text>
                                                            {option.label}
                                                          </Text>
                                                        </HStack>
                                                      </Box>
                                                    )
                                                )}
                                            </div>
                                          </Stack>
                                        </Box>
                                      )}

                                      {schemaField.field_type ===
                                        GeneialFieldVersionTypeEnum.dropdown && (
                                        <Box>
                                          <FormSelectControl
                                            label={
                                              <Box>
                                                {schemaField?.display_name ||
                                                schemaField.field_key}
                                              </Box>
                                            }
                                            formControlProps={{isRequired:schemaField?.is_required}}
                                            description={schemaField?.help_text}
                                            isIncludeDescription={true}
                                            name={schemaField.field_key}
                                            placeholder="Select an option..."
                                            options={
                                              schemaField.options
                                                ? schemaField.options.map(
                                                    (option) => ({
                                                      label: option.label,
                                                      value:
                                                        option.value.toString(),
                                                    })
                                                  )
                                                : []
                                            }
                                          ></FormSelectControl>
                                        </Box>
                                      )}

                                      {![
                                        GeneialFieldVersionTypeEnum.checkbox,
                                        GeneialFieldVersionTypeEnum.yesno,
                                        GeneialFieldVersionTypeEnum.dropdown,
                                        GeneialFieldVersionTypeEnum.radio,
                                      ].includes(schemaField.field_type) && (
                                        <Stack>
                                          <FormInputControl
                                            label={
                                              <Box>
                                                {schemaField?.display_name ||
                                                schemaField.field_key}
                                              </Box>
                                            }
                                            formControlProps={{isRequired:schemaField?.is_required}}
                                            description={schemaField?.help_text}
                                            isIncludeDescription={true}
                                            name={schemaField?.field_key}
                                          />
                                          {schemaField.field_key === "dob" && (
                                            <Text
                                              textStyle={"badge"}
                                              color="text.soft"
                                            >
                                              YYYY-MM-DD
                                            </Text>
                                          )}
                                        </Stack>
                                      )}
                                    </Box>
                                  </Stack>
                                );
                              })}
                        </Stack>
                      </Stack>
                    );
                  })}

                <ButtonGroup w="full" justifyContent={"space-between"}>
                  <Button onClick={onClose}>Close</Button>

                  <Button
                    type="submit"
                    isLoading={isLoading}
                    loadingText="Adding record"
                    colorScheme={"primary"}
                  >
                    Add record
                  </Button>
                </ButtonGroup>
              </Stack>
            </FormikForm>
          );
        }}
      </Formik>
    </Box>
  );
};
